import { useEffect, useState, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import * as api from "../../../api";
import { supabase } from "../../../lib/supabaseClient";
import Spinner from "../../Atoms/Spinner";
import * as XLSX from "xlsx";

// ─── Constants ──────────────────────────────────────────────
const EVENT_ID = "67590da5499bcc995c210b40";

const WINNER_PROJECT_IDS = [
    '67a332e21b103d938bafb0dc', '67a0b8331b103d938bafa954', '67aa1011740d844a3d633e93',
    '6829daa5754f51df2ef9141c', '67e6c18043d5609350e381a8', '67b5e6146890f1a147192905',
    '67be4a58b1ba28c3144aeb73', '67bf2330b1ba28c3144af8d2', '67c090dcdb48cb16a13c5b43',
    '677268097ec5d90c89d6fe63', '67c6b416db48cb16a13c73c7', '67ab652c07736060460b3b75',
    '68348986754f51df2ef9b87c', '67d15108d95ccf24eaf191df', '67d7d38c43d5609350e242a1',
    '67d82d2243d5609350e24c5e', '662adc507159e5b1b1da7c75', '67d8718c43d5609350e25c38',
    '67d1977243d5609350e218f2', '682b5c5f754f51df2ef93bbc', '67da910a43d5609350e274d7',
    '67e1864b43d5609350e2baeb', '67daebf343d5609350e27a9e', '67dd585043d5609350e28e57',
    '67dfeb0e43d5609350e2a360', '67e1452a43d5609350e2b066', '678675e2de3ed4a7001ab532',
    '67e2d05943d5609350e2cf97', '67e3e1cb43d5609350e304e5', '67e3e81543d5609350e308de',
    '67e3f02643d5609350e30a0a', '67e42d7043d5609350e32539', '67e42e5543d5609350e32570',
    '67e45c9843d5609350e329c0', '67e529f743d5609350e33a8c', '67e53aab43d5609350e340c3',
    '67e56ab043d5609350e3490f', '67e5764d43d5609350e34cb5', '67e57f5143d5609350e3519a',
    '67e5864c43d5609350e353a3', '67e58da443d5609350e3561d', '67e58ebc43d5609350e35665',
    '67e5ab6b43d5609350e35905', '67e6828d43d5609350e36b6a', '67e6acaf43d5609350e37832',
    '67e51ddb43d5609350e33667', '67e6c0a843d5609350e380cf', '67e6d53a43d5609350e38725',
    '67e6dfff43d5609350e38900', '67e7003c43d5609350e38bfc', '6834625c754f51df2ef9a4b1',
    '67ea99b76b7945ed1a576bae', '67f90250a0262e085d37088f', '67e1741a43d5609350e2b608',
    '67fe7a6c9167c049fff4e37e', '67ab6ade07736060460b3c16', '6810a343264e7745556acae1',
    '6800f4c59167c049fff51f5d', '6800b8529167c049fff50e47', '6800e76e9167c049fff5197f',
    '6800ef849167c049fff51c6f', '6800fad59167c049fff52224', '680113739167c049fff52d73',
    '680106139167c049fff525af', '680125219167c049fff53405', '680957ab9167c049fff5a7c2',
    '681164d36c8fbfe5e3c91e9e', '68020ef79167c049fff54015', '68025d069167c049fff56132',
    '680b728c9167c049fff5c8f7', '680249249167c049fff55a19', '68024ed89167c049fff55b90',
    '68025b1a9167c049fff56037', '680270379167c049fff566f5', '680274c09167c049fff567c8',
    '680275419167c049fff567de', '68027b389167c049fff56954', '680291609167c049fff56cad',
    '6802a3fc9167c049fff56f5f', '6849787b17dde4ca4c4bf043', '6849435a17dde4ca4c4be251',
    '6807cb759167c049fff58dd4', '6808c3f59167c049fff599c7', '6808c3859167c049fff599b1',
    '680fa4b19167c049fff5deee', '6801e2f49167c049fff53ce1', '680a54a09167c049fff5bbc4',
    '680b94b29167c049fff5cd49', '6810df4a264e7745556ad75d', '680fa3f89167c049fff5deb1',
    '680fa844a71ddf126b77b977', '680fa9f09167c049fff5e027', '6810c9b9264e7745556acf4d',
    '681125b66c8fbfe5e3c91c62', '6818cac19e656d77bc6c72fa', '6818d27e9e656d77bc6c75a3',
    '6818dbdf9e656d77bc6c78a0', '682d97b2754f51df2ef96070', '67fccffaa0262e085d370ddc',
    '680271809167c049fff5674a',
];

// ─── Styled Components ──────────────────────────────────────
const PageWrapper = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    padding: 32px 24px 60px;
`;

const Header = styled.div`
    margin-bottom: 32px;
`;

const Title = styled.h1`
    font-size: 32px;
    font-weight: 800;
    color: #1a1a1a;
    margin: 0 0 6px 0;
`;

const Subtitle = styled.p`
    font-size: 16px;
    color: #888;
    margin: 0;
`;

const StatsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-bottom: 32px;
`;

const StatCard = styled.div`
    background: ${props => props.bg || 'white'};
    padding: 24px;
    border-radius: 14px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
    border: 1px solid #eee;
`;

const StatValue = styled.div`
    font-size: 36px;
    font-weight: 800;
    color: ${props => props.color || '#1a1a1a'};
    line-height: 1;
    margin-bottom: 6px;
`;

const StatLabel = styled.div`
    font-size: 13px;
    color: #888;
    font-weight: 500;
`;

const StatSub = styled.div`
    font-size: 12px;
    color: #aaa;
    margin-top: 4px;
`;

const TabsRow = styled.div`
    display: flex;
    gap: 4px;
    margin-bottom: 20px;
    border-bottom: 2px solid #eee;
`;

const Tab = styled.button`
    padding: 12px 24px;
    border: none;
    background: none;
    font-size: 14px;
    font-weight: 600;
    color: ${props => props.active ? 'rgb(24, 51, 189)' : '#888'};
    border-bottom: 3px solid ${props => props.active ? 'rgb(24, 51, 189)' : 'transparent'};
    cursor: pointer;
    transition: all 0.2s;
    margin-bottom: -2px;

    &:hover {
        color: rgb(24, 51, 189);
    }
`;

const ToolbarRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;
    flex-wrap: wrap;
`;

const SearchInput = styled.input`
    padding: 10px 16px;
    border: 1.5px solid #ddd;
    border-radius: 10px;
    font-size: 14px;
    outline: none;
    width: 300px;
    transition: border-color 0.2s;

    &:focus {
        border-color: rgb(24, 51, 189);
        box-shadow: 0 0 0 3px rgba(24, 51, 189, 0.08);
    }

    &::placeholder { color: #bbb; }

    @media (max-width: 600px) { width: 100%; }
`;

const FilterSelect = styled.select`
    padding: 10px 14px;
    border: 1.5px solid #ddd;
    border-radius: 10px;
    font-size: 14px;
    outline: none;
    background: white;
    cursor: pointer;

    &:focus {
        border-color: rgb(24, 51, 189);
    }
`;

const ExportBtn = styled.button`
    padding: 10px 20px;
    background: linear-gradient(135deg, #4caf50, #43a047);
    color: white;
    border: none;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
    }
`;

const RefreshBtn = styled.button`
    padding: 10px 20px;
    background: white;
    color: #555;
    border: 1.5px solid #ddd;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        border-color: #999;
        background: #f8f8f8;
    }
`;

const TableContainer = styled.div`
    background: white;
    border-radius: 14px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
    border: 1px solid #eee;
    overflow: hidden;
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

const Th = styled.th`
    background: #f8f9fa;
    padding: 14px 16px;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    color: #666;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid #eee;
    white-space: nowrap;
    cursor: ${props => props.sortable ? 'pointer' : 'default'};
    user-select: none;

    &:hover {
        ${props => props.sortable && 'color: rgb(24, 51, 189);'}
    }
`;

const Td = styled.td`
    padding: 12px 16px;
    font-size: 14px;
    color: #333;
    border-bottom: 1px solid #f0f0f0;
    vertical-align: middle;
`;

const Tr = styled.tr`
    transition: background 0.15s;

    &:hover {
        background: #f8f9ff;
    }
`;

const RankBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    font-weight: 800;
    font-size: 13px;
    color: white;
    background: ${props => {
        if (props.rank === 1) return 'linear-gradient(135deg, #FFD700, #FFA000)';
        if (props.rank === 2) return 'linear-gradient(135deg, #C0C0C0, #9E9E9E)';
        if (props.rank === 3) return 'linear-gradient(135deg, #CD7F32, #A0522D)';
        return '#e0e0e0';
    }};
    ${props => props.rank > 3 && 'color: #666;'}
`;

const TypeBadge = styled.span`
    padding: 3px 10px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    background: ${props => props.type === 'objet'
        ? 'rgba(24, 51, 189, 0.1)'
        : 'rgba(0, 137, 123, 0.1)'};
    color: ${props => props.type === 'objet'
        ? 'rgb(24, 51, 189)'
        : 'rgb(0, 137, 123)'};
`;

const VoteBar = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const VoteBarTrack = styled.div`
    flex: 1;
    height: 8px;
    background: #eee;
    border-radius: 4px;
    overflow: hidden;
    min-width: 80px;
`;

const VoteBarFill = styled.div`
    height: 100%;
    background: linear-gradient(90deg, rgb(24, 51, 189), rgb(67, 97, 238));
    border-radius: 4px;
    transition: width 0.3s ease;
`;

const VoteCount = styled.span`
    font-weight: 700;
    font-size: 14px;
    color: #333;
    min-width: 30px;
`;

const ProjectThumb = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 8px;
    background-size: cover;
    background-position: center;
    background-color: #f0f0f0;
    flex-shrink: 0;
`;

const ProjectCell = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
`;

const ProjectName = styled.span`
    font-weight: 600;
    color: #1a1a1a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 280px;
    display: block;
`;

const DesignerName = styled.span`
    font-size: 12px;
    color: #888;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 280px;
`;

const NewsletterBadge = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    background: ${props => props.yes ? '#e8f5e9' : '#f5f5f5'};
    color: ${props => props.yes ? '#2e7d32' : '#999'};
`;

const Pagination = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 16px;
    border-top: 1px solid #eee;
`;

const PageBtn = styled.button`
    padding: 8px 14px;
    border: 1.5px solid ${props => props.active ? 'rgb(24, 51, 189)' : '#ddd'};
    background: ${props => props.active ? 'rgb(24, 51, 189)' : 'white'};
    color: ${props => props.active ? 'white' : '#555'};
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;

    &:hover:not(:disabled) {
        border-color: rgb(24, 51, 189);
    }

    &:disabled {
        opacity: 0.4;
        cursor: default;
    }
`;

const EmptyState = styled.div`
    text-align: center;
    padding: 48px 20px;
    color: #999;
    font-size: 15px;
`;

const LoadingWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 80px 20px;
`;

const DeleteBtn = styled.button`
    padding: 4px 10px;
    background: #fff0f0;
    color: #c0392b;
    border: 1px solid #f5c6cb;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background: #c0392b;
        color: white;
    }
`;

// ─── Component ──────────────────────────────────────────────
const FD100PrixDuPublic = (props) => {
    const navigate = useNavigate();
    const [votes, setVotes] = useState(null);
    const [definitiveNames, setDefinitiveNames] = useState({});
    const [projectEnrichment, setProjectEnrichment] = useState({}); // type + image from API
    const [loading, setLoading] = useState(true);
    const [tab, setTab] = useState("classement");
    const [search, setSearch] = useState("");
    const [typeFilter, setTypeFilter] = useState("all");
    const [sortField, setSortField] = useState("votes");
    const [sortDir, setSortDir] = useState("desc");
    const [voterPage, setVoterPage] = useState(1);
    const VOTERS_PER_PAGE = 50;

    // Auth check
    useEffect(() => {
        if (props.fullUserLoading) return;
        if (!props.fullUser?.user) navigate("/");
        if (props.fullUser?.user && props.fullUser.user.role !== "admin") navigate("/");
    }, [props.fullUserLoading, props.fullUser, navigate]);

    // Fetch votes from Supabase (paginate to avoid default 1000-row limit)
    const fetchVotes = useCallback(async () => {
        const all = [];
        const PAGE_SIZE = 1000;
        let from = 0;
        while (true) {
            const { data } = await supabase
                .from("fd100_votes")
                .select("*")
                .order("created_at", { ascending: false })
                .range(from, from + PAGE_SIZE - 1);
            if (!data || data.length === 0) break;
            all.push(...data);
            if (data.length < PAGE_SIZE) break;
            from += PAGE_SIZE;
        }
        if (all.length > 0) setVotes(all);
    }, []);

    // Fetch definitive names from Supabase (fast, primary data source)
    const fetchNames = useCallback(async () => {
        const { data } = await supabase
            .from("fd100_project_names")
            .select("*")
            .eq("event_id", EVENT_ID);
        if (data) {
            const map = {};
            data.forEach(item => {
                map[item.project_id] = {
                    name_fr: item.name_definitive_fr,
                    name_en: item.name_definitive_en,
                    designer: item.designer_definitive,
                };
            });
            setDefinitiveNames(map);
        }
        setLoading(false);
    }, []);

    // Non-blocking enrichment: fetch type + images directly from companies (fast, single query)
    const fetchEnrichment = useCallback(() => {
        api.getProjectsBasicData({ projectIds: WINNER_PROJECT_IDS }).then((response) => {
            const enrichMap = {};
            Object.entries(response.data).forEach(([pid, data]) => {
                enrichMap[pid] = {
                    type: data.type,
                    image: data.imagePath
                        ? process.env.REACT_APP_MEDIA_BASE_URL + 'userfiles/' + data.imagePath
                        : null,
                };
            });
            setProjectEnrichment(enrichMap);
        }).catch(err => {
            console.warn('Enrichment API failed (non-blocking):', err.message);
        });
    }, []);

    // Fetch data on mount
    useEffect(() => {
        fetchVotes();
        fetchNames();
        fetchEnrichment(); // non-blocking, page works without it
    }, [fetchVotes, fetchNames, fetchEnrichment]);

    // ─── Helpers ────────────────────────────────────────────
    const getProjectName = useCallback((projectId) => {
        const def = definitiveNames[projectId];
        return def?.name_fr || def?.name_en || projectId;
    }, [definitiveNames]);

    const getDesignerName = useCallback((projectId) => {
        const def = definitiveNames[projectId];
        return def?.designer || '';
    }, [definitiveNames]);

    const getProjectType = useCallback((projectId) => {
        return projectEnrichment[projectId]?.type || 'objet';
    }, [projectEnrichment]);

    const getProjectImage = useCallback((projectId) => {
        return projectEnrichment[projectId]?.image || null;
    }, [projectEnrichment]);

    // Vote counts per project
    const voteCounts = useMemo(() => {
        if (!votes) return {};
        const counts = {};
        votes.forEach(v => {
            counts[v.project_id] = (counts[v.project_id] || 0) + 1;
        });
        return counts;
    }, [votes]);

    const maxVotes = useMemo(() => Math.max(...Object.values(voteCounts), 1), [voteCounts]);

    // Rankings data — built from WINNER_PROJECT_IDS + Supabase names + API enrichment
    const rankingsData = useMemo(() => {
        const entries = WINNER_PROJECT_IDS.map(pid => ({
            projectId: pid,
            name: getProjectName(pid),
            designer: getDesignerName(pid),
            type: getProjectType(pid),
            votes: voteCounts[pid] || 0,
            image: getProjectImage(pid),
        }));

        // Filter
        let filtered = entries;
        if (typeFilter !== "all") {
            filtered = filtered.filter(e => e.type === typeFilter);
        }
        if (search.trim()) {
            const q = search.trim().toLowerCase();
            filtered = filtered.filter(e =>
                e.name.toLowerCase().includes(q) ||
                e.designer.toLowerCase().includes(q)
            );
        }

        // Sort
        filtered.sort((a, b) => {
            let cmp = 0;
            if (sortField === "votes") cmp = a.votes - b.votes;
            else if (sortField === "name") cmp = a.name.localeCompare(b.name);
            else if (sortField === "designer") cmp = a.designer.localeCompare(b.designer);
            else if (sortField === "type") cmp = a.type.localeCompare(b.type);
            return sortDir === "desc" ? -cmp : cmp;
        });

        // Assign ranks (based on votes desc, regardless of current sort)
        const byVotes = [...entries].sort((a, b) => b.votes - a.votes);
        const rankMap = {};
        byVotes.forEach((e, idx) => { rankMap[e.projectId] = idx + 1; });
        filtered.forEach(e => { e.rank = rankMap[e.projectId]; });

        return filtered;
    }, [voteCounts, typeFilter, search, sortField, sortDir, getProjectName, getDesignerName, getProjectType, getProjectImage]);

    // Voters data (individual votes)
    const votersData = useMemo(() => {
        if (!votes) return [];
        let filtered = votes.map(v => ({
            ...v,
            projectName: getProjectName(v.project_id),
            designerName: getDesignerName(v.project_id),
            projectType: getProjectType(v.project_id),
        }));

        if (search.trim()) {
            const q = search.trim().toLowerCase();
            filtered = filtered.filter(v =>
                (v.voter_email || '').toLowerCase().includes(q) ||
                (v.voter_name || '').toLowerCase().includes(q) ||
                v.projectName.toLowerCase().includes(q)
            );
        }

        return filtered;
    }, [votes, search, getProjectName, getDesignerName, getProjectType]);

    // Stats
    const stats = useMemo(() => {
        if (!votes) return { total: 0, uniqueVoters: 0, projectsWithVotes: 0, newsletterOptIn: 0, avgPerProject: 0 };
        const uniqueEmails = new Set(votes.map(v => v.voter_email));
        const projectsVoted = new Set(votes.map(v => v.project_id));
        const newsletterCount = votes.filter(v => v.newsletter_opt_in).length;
        return {
            total: votes.length,
            uniqueVoters: uniqueEmails.size,
            projectsWithVotes: projectsVoted.size,
            newsletterOptIn: newsletterCount,
            avgPerProject: projectsVoted.size > 0 ? (votes.length / projectsVoted.size).toFixed(1) : 0,
        };
    }, [votes]);

    // UTM stats
    const utmStats = useMemo(() => {
        if (!votes) return { total: 0, sources: {} };
        const withUtm = votes.filter(v => v.utm_source);
        const sources = {};
        withUtm.forEach(v => {
            const key = `${v.utm_source} / ${v.utm_medium || '—'}`;
            if (!sources[key]) sources[key] = { source: v.utm_source, medium: v.utm_medium || '—', campaign: v.utm_campaign || '—', count: 0 };
            sources[key].count++;
        });
        const sorted = Object.values(sources).sort((a, b) => b.count - a.count);
        return { total: withUtm.length, sources: sorted };
    }, [votes]);

    // Top project
    const topProject = useMemo(() => {
        if (!rankingsData.length) return null;
        const sorted = [...rankingsData].sort((a, b) => b.votes - a.votes);
        return sorted[0];
    }, [rankingsData]);

    // Unique voters data (aggregated by email)
    const uniqueVotersData = useMemo(() => {
        if (!votes) return [];
        const emailMap = {};
        votes.forEach(v => {
            const email = (v.voter_email || '').toLowerCase();
            if (!emailMap[email]) {
                emailMap[email] = {
                    email: v.voter_email,
                    name: v.voter_name || '',
                    newsletter: v.newsletter_opt_in,
                    votesCount: 0,
                    projects: [],
                    firstVote: v.created_at,
                    lastVote: v.created_at,
                };
            }
            emailMap[email].votesCount++;
            emailMap[email].projects.push(getProjectName(v.project_id));
            if (v.created_at < emailMap[email].firstVote) emailMap[email].firstVote = v.created_at;
            if (v.created_at > emailMap[email].lastVote) emailMap[email].lastVote = v.created_at;
            if (v.voter_name && !emailMap[email].name) emailMap[email].name = v.voter_name;
        });

        let result = Object.values(emailMap);

        if (search.trim()) {
            const q = search.trim().toLowerCase();
            result = result.filter(v =>
                v.email.toLowerCase().includes(q) ||
                v.name.toLowerCase().includes(q)
            );
        }

        result.sort((a, b) => b.votesCount - a.votesCount);
        return result;
    }, [votes, search, getProjectName]);

    // Pagination for voters
    const paginatedVoters = useMemo(() => {
        const start = (voterPage - 1) * VOTERS_PER_PAGE;
        return tab === "voters"
            ? votersData.slice(start, start + VOTERS_PER_PAGE)
            : uniqueVotersData.slice(start, start + VOTERS_PER_PAGE);
    }, [tab, votersData, uniqueVotersData, voterPage]);

    const totalPages = useMemo(() => {
        const total = tab === "voters" ? votersData.length : uniqueVotersData.length;
        return Math.ceil(total / VOTERS_PER_PAGE);
    }, [tab, votersData, uniqueVotersData]);

    // Reset page on tab/search change
    useEffect(() => { setVoterPage(1); }, [tab, search]);

    // Sort handler
    const handleSort = (field) => {
        if (sortField === field) {
            setSortDir(prev => prev === "desc" ? "asc" : "desc");
        } else {
            setSortField(field);
            setSortDir("desc");
        }
    };

    // Delete vote
    const handleDeleteVote = async (voteId) => {
        if (!window.confirm("Supprimer ce vote ?")) return;
        const { error } = await supabase
            .from("fd100_votes")
            .delete()
            .eq("id", voteId);
        if (!error) {
            setVotes(prev => prev.filter(v => v.id !== voteId));
        }
    };

    // Export rankings
    const exportRankings = () => {
        const rows = [["Rang", "Projet", "Designer", "Type", "Votes"]];
        const sorted = [...rankingsData].sort((a, b) => b.votes - a.votes);
        sorted.forEach((e, idx) => {
            rows.push([idx + 1, e.name, e.designer, e.type, e.votes]);
        });
        const ws = XLSX.utils.aoa_to_sheet(rows);
        ws['!cols'] = [{ wch: 6 }, { wch: 40 }, { wch: 30 }, { wch: 10 }, { wch: 8 }];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Classement");
        XLSX.writeFile(wb, `fd100_prix_du_public_classement_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    // Export all votes
    const exportVotes = () => {
        const rows = [["Email", "Nom", "Projet", "Designer", "Type", "Newsletter", "Date"]];
        votersData.forEach(v => {
            rows.push([
                v.voter_email,
                v.voter_name || '',
                v.projectName,
                v.designerName,
                v.projectType,
                v.newsletter_opt_in ? 'Oui' : 'Non',
                v.created_at ? new Date(v.created_at).toLocaleString('fr-FR') : '',
            ]);
        });
        const ws = XLSX.utils.aoa_to_sheet(rows);
        ws['!cols'] = [{ wch: 30 }, { wch: 25 }, { wch: 40 }, { wch: 30 }, { wch: 10 }, { wch: 12 }, { wch: 20 }];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Votes");
        XLSX.writeFile(wb, `fd100_prix_du_public_votes_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    // Export unique voters
    const exportUniqueVoters = () => {
        const rows = [["Email", "Nom", "Nb votes", "Newsletter", "Projets votés", "Premier vote", "Dernier vote"]];
        uniqueVotersData.forEach(v => {
            rows.push([
                v.email,
                v.name,
                v.votesCount,
                v.newsletter ? 'Oui' : 'Non',
                v.projects.join(', '),
                v.firstVote ? new Date(v.firstVote).toLocaleString('fr-FR') : '',
                v.lastVote ? new Date(v.lastVote).toLocaleString('fr-FR') : '',
            ]);
        });
        const ws = XLSX.utils.aoa_to_sheet(rows);
        ws['!cols'] = [{ wch: 30 }, { wch: 25 }, { wch: 10 }, { wch: 12 }, { wch: 60 }, { wch: 20 }, { wch: 20 }];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Votants");
        XLSX.writeFile(wb, `fd100_prix_du_public_votants_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    if (loading || !votes) {
        return (
            <PageWrapper>
                <Header>
                    <Title>Prix du Public - Suivi</Title>
                </Header>
                <LoadingWrapper><Spinner /></LoadingWrapper>
            </PageWrapper>
        );
    }

    return (
        <PageWrapper>
            <Header>
                <Title>Prix du Public - Suivi</Title>
                <Subtitle>
                    {stats.total} votes au total &middot; {stats.uniqueVoters} votants uniques &middot; {stats.projectsWithVotes} projets votés
                </Subtitle>
            </Header>

            {/* Stats */}
            <StatsGrid>
                <StatCard>
                    <StatValue color="rgb(24, 51, 189)">{stats.total}</StatValue>
                    <StatLabel>Votes totaux</StatLabel>
                </StatCard>
                <StatCard>
                    <StatValue color="#e67e22">{stats.uniqueVoters}</StatValue>
                    <StatLabel>Votants uniques</StatLabel>
                    <StatSub>{stats.avgPerProject} votes/projet en moyenne</StatSub>
                </StatCard>
                <StatCard>
                    <StatValue color="#27ae60">{stats.projectsWithVotes}</StatValue>
                    <StatLabel>Projets avec votes</StatLabel>
                    <StatSub>sur {WINNER_PROJECT_IDS.length} projets</StatSub>
                </StatCard>
                <StatCard>
                    <StatValue color="#8e44ad">{stats.newsletterOptIn}</StatValue>
                    <StatLabel>Opt-in newsletter</StatLabel>
                    <StatSub>{stats.total > 0 ? Math.round(stats.newsletterOptIn / stats.total * 100) : 0}% des votes</StatSub>
                </StatCard>
                {utmStats.total > 0 && (
                    <StatCard bg="#fff8e1">
                        <StatValue color="#e65100">{utmStats.total}</StatValue>
                        <StatLabel>Votes via campagnes UTM</StatLabel>
                        <StatSub>{stats.total > 0 ? Math.round(utmStats.total / stats.total * 100) : 0}% du total</StatSub>
                    </StatCard>
                )}
                {topProject && (
                    <StatCard bg="#f0f4ff">
                        <StatValue color="rgb(24, 51, 189)" style={{ fontSize: 20 }}>{topProject.name}</StatValue>
                        <StatLabel>N°1 avec {topProject.votes} votes</StatLabel>
                        <StatSub>{topProject.designer}</StatSub>
                    </StatCard>
                )}
            </StatsGrid>

            {/* Tabs */}
            <TabsRow>
                <Tab active={tab === "classement"} onClick={() => setTab("classement")}>
                    Classement ({rankingsData.length})
                </Tab>
                <Tab active={tab === "voters"} onClick={() => setTab("voters")}>
                    Tous les votes ({votersData.length})
                </Tab>
                <Tab active={tab === "unique"} onClick={() => setTab("unique")}>
                    Votants uniques ({uniqueVotersData.length})
                </Tab>
                <Tab active={tab === "sources"} onClick={() => setTab("sources")}>
                    Sources UTM ({utmStats.total})
                </Tab>
            </TabsRow>

            {/* Toolbar */}
            <ToolbarRow>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                    <SearchInput
                        placeholder={tab === "classement" ? "Rechercher un projet..." : "Rechercher un votant ou projet..."}
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                    {tab === "classement" && (
                        <FilterSelect value={typeFilter} onChange={e => setTypeFilter(e.target.value)}>
                            <option value="all">Tous types</option>
                            <option value="objet">Objets</option>
                            <option value="espace">Espaces</option>
                        </FilterSelect>
                    )}
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                    <RefreshBtn onClick={() => { fetchVotes(); fetchNames(); fetchEnrichment(); }}>Rafraîchir</RefreshBtn>
                    <ExportBtn onClick={
                        tab === "classement" ? exportRankings
                            : tab === "voters" ? exportVotes
                                : exportUniqueVoters
                    }>
                        Exporter XLSX
                    </ExportBtn>
                </div>
            </ToolbarRow>

            {/* Rankings Table */}
            {tab === "classement" && (
                <TableContainer>
                    <div style={{ overflowX: 'auto' }}>
                        <Table>
                            <thead>
                                <tr>
                                    <Th style={{ width: 60 }}>#</Th>
                                    <Th sortable onClick={() => handleSort("name")}>
                                        Projet {sortField === "name" && (sortDir === "asc" ? "▲" : "▼")}
                                    </Th>
                                    <Th sortable onClick={() => handleSort("designer")}>
                                        Designer {sortField === "designer" && (sortDir === "asc" ? "▲" : "▼")}
                                    </Th>
                                    <Th sortable onClick={() => handleSort("type")}>
                                        Type {sortField === "type" && (sortDir === "asc" ? "▲" : "▼")}
                                    </Th>
                                    <Th sortable onClick={() => handleSort("votes")} style={{ minWidth: 200 }}>
                                        Votes {sortField === "votes" && (sortDir === "asc" ? "▲" : "▼")}
                                    </Th>
                                </tr>
                            </thead>
                            <tbody>
                                {rankingsData.length === 0 ? (
                                    <tr><Td colSpan={5}><EmptyState>Aucun résultat</EmptyState></Td></tr>
                                ) : (
                                    rankingsData.map(entry => (
                                        <Tr key={entry.projectId}>
                                            <Td>
                                                <RankBadge rank={entry.rank}>
                                                    {entry.rank}
                                                </RankBadge>
                                            </Td>
                                            <Td>
                                                <ProjectCell>
                                                    {entry.image && <ProjectThumb style={{ backgroundImage: `url(${entry.image})` }} />}
                                                    <div>
                                                        <ProjectName>{entry.name}</ProjectName>
                                                    </div>
                                                </ProjectCell>
                                            </Td>
                                            <Td><DesignerName style={{ fontSize: 14 }}>{entry.designer}</DesignerName></Td>
                                            <Td><TypeBadge type={entry.type}>{entry.type === 'objet' ? 'Objet' : 'Espace'}</TypeBadge></Td>
                                            <Td>
                                                <VoteBar>
                                                    <VoteCount>{entry.votes}</VoteCount>
                                                    <VoteBarTrack>
                                                        <VoteBarFill style={{ width: `${(entry.votes / maxVotes) * 100}%` }} />
                                                    </VoteBarTrack>
                                                </VoteBar>
                                            </Td>
                                        </Tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>
                </TableContainer>
            )}

            {/* All Votes Table */}
            {tab === "voters" && (
                <TableContainer>
                    <div style={{ overflowX: 'auto' }}>
                        <Table>
                            <thead>
                                <tr>
                                    <Th>Email</Th>
                                    <Th>Nom</Th>
                                    <Th>Projet</Th>
                                    <Th>Type</Th>
                                    <Th>Newsletter</Th>
                                    <Th>Date</Th>
                                    <Th style={{ width: 80 }}></Th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedVoters.length === 0 ? (
                                    <tr><Td colSpan={7}><EmptyState>Aucun vote</EmptyState></Td></tr>
                                ) : (
                                    paginatedVoters.map(v => (
                                        <Tr key={v.id}>
                                            <Td style={{ fontWeight: 500 }}>{v.voter_email}</Td>
                                            <Td>{v.voter_name || '—'}</Td>
                                            <Td>
                                                <ProjectName style={{ maxWidth: 200 }}>{v.projectName}</ProjectName>
                                                <DesignerName>{v.designerName}</DesignerName>
                                            </Td>
                                            <Td>
                                                {v.projectType && <TypeBadge type={v.projectType}>{v.projectType === 'objet' ? 'Objet' : 'Espace'}</TypeBadge>}
                                            </Td>
                                            <Td>
                                                <NewsletterBadge yes={v.newsletter_opt_in}>
                                                    {v.newsletter_opt_in ? 'Oui' : 'Non'}
                                                </NewsletterBadge>
                                            </Td>
                                            <Td style={{ fontSize: 13, color: '#888', whiteSpace: 'nowrap' }}>
                                                {v.created_at ? new Date(v.created_at).toLocaleString('fr-FR') : '—'}
                                            </Td>
                                            <Td>
                                                <DeleteBtn onClick={() => handleDeleteVote(v.id)}>
                                                    Suppr.
                                                </DeleteBtn>
                                            </Td>
                                        </Tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>
                    {totalPages > 1 && (
                        <Pagination>
                            <PageBtn disabled={voterPage === 1} onClick={() => setVoterPage(p => p - 1)}>
                                ← Préc.
                            </PageBtn>
                            <span style={{ fontSize: 13, color: '#888' }}>
                                Page {voterPage} / {totalPages}
                            </span>
                            <PageBtn disabled={voterPage === totalPages} onClick={() => setVoterPage(p => p + 1)}>
                                Suiv. →
                            </PageBtn>
                        </Pagination>
                    )}
                </TableContainer>
            )}

            {/* Unique Voters Table */}
            {tab === "unique" && (
                <TableContainer>
                    <div style={{ overflowX: 'auto' }}>
                        <Table>
                            <thead>
                                <tr>
                                    <Th>Email</Th>
                                    <Th>Nom</Th>
                                    <Th>Nb votes</Th>
                                    <Th>Newsletter</Th>
                                    <Th>Premier vote</Th>
                                    <Th>Dernier vote</Th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedVoters.length === 0 ? (
                                    <tr><Td colSpan={6}><EmptyState>Aucun votant</EmptyState></Td></tr>
                                ) : (
                                    paginatedVoters.map(v => (
                                        <Tr key={v.email}>
                                            <Td style={{ fontWeight: 500 }}>{v.email}</Td>
                                            <Td>{v.name || '—'}</Td>
                                            <Td>
                                                <VoteCount>{v.votesCount}</VoteCount>
                                            </Td>
                                            <Td>
                                                <NewsletterBadge yes={v.newsletter}>
                                                    {v.newsletter ? 'Oui' : 'Non'}
                                                </NewsletterBadge>
                                            </Td>
                                            <Td style={{ fontSize: 13, color: '#888', whiteSpace: 'nowrap' }}>
                                                {v.firstVote ? new Date(v.firstVote).toLocaleString('fr-FR') : '—'}
                                            </Td>
                                            <Td style={{ fontSize: 13, color: '#888', whiteSpace: 'nowrap' }}>
                                                {v.lastVote ? new Date(v.lastVote).toLocaleString('fr-FR') : '—'}
                                            </Td>
                                        </Tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>
                    {totalPages > 1 && (
                        <Pagination>
                            <PageBtn disabled={voterPage === 1} onClick={() => setVoterPage(p => p - 1)}>
                                ← Préc.
                            </PageBtn>
                            <span style={{ fontSize: 13, color: '#888' }}>
                                Page {voterPage} / {totalPages}
                            </span>
                            <PageBtn disabled={voterPage === totalPages} onClick={() => setVoterPage(p => p + 1)}>
                                Suiv. →
                            </PageBtn>
                        </Pagination>
                    )}
                </TableContainer>
            )}

            {/* UTM Sources Table */}
            {tab === "sources" && (
                <TableContainer>
                    <div style={{ overflowX: 'auto' }}>
                        <Table>
                            <thead>
                                <tr>
                                    <Th>Source</Th>
                                    <Th>Medium</Th>
                                    <Th>Campagne</Th>
                                    <Th style={{ minWidth: 150 }}>Votes</Th>
                                </tr>
                            </thead>
                            <tbody>
                                {utmStats.sources.length === 0 ? (
                                    <tr><Td colSpan={4}><EmptyState>Aucun vote avec UTM pour le moment</EmptyState></Td></tr>
                                ) : (
                                    utmStats.sources.map((s, idx) => (
                                        <Tr key={idx}>
                                            <Td style={{ fontWeight: 600 }}>{s.source}</Td>
                                            <Td>{s.medium}</Td>
                                            <Td>{s.campaign}</Td>
                                            <Td>
                                                <VoteBar>
                                                    <VoteCount>{s.count}</VoteCount>
                                                    <VoteBarTrack>
                                                        <VoteBarFill style={{ width: `${(s.count / (utmStats.sources[0]?.count || 1)) * 100}%` }} />
                                                    </VoteBarTrack>
                                                </VoteBar>
                                            </Td>
                                        </Tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>
                </TableContainer>
            )}
        </PageWrapper>
    );
};

export default FD100PrixDuPublic;
